import { color } from "src/styles/globals";
import styled from "styled-components";
import {
  Button as SundayButton,
  Title as SundayComponent,
} from "sunday-component";

export const StepNumber = styled(SundayComponent).attrs({ level: 7 })`
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${color.carrotOrange03};
  width: 24px;
  height: 24px;
  color: ${color.white};
  flex-shrink: 0;
`;

export const ConsentButton = styled(SundayButton).attrs({ type: "text" })`
  padding: 0px;
  height: fit-content !important;
  width: fit-content;
  margin-top: 4px;
`;
